import App from '@/vue-components/App.vue'
import {i18n} from './vue-components/i18n'
import moment from 'moment'
import VueGtag from 'vue-gtag'
import {gtagConfig, analyticsIds, pixelIds} from './utils/gtag'
import browserDetect from 'vue-browser-detect-plugin'
import '../styles/index.scss';

Vue.prototype.moment = moment
if (analyticsIds.length) Vue.use(VueGtag, gtagConfig)
Vue.use(browserDetect)

if (pixelIds.length) {
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
  pixelIds.forEach(id => {
    fbq('init', id);
  })
  // fbq('init', '959305944540050');
  fbq('track', 'PageView');
}

new Vue({
  el: '#container',
  i18n,
  render: h => h(App)
})

